import { Joi, objectSchemaOf } from '../helpers';

export const errorInfoSchema = objectSchemaOf<IErrorInfo>({
  status: Joi.string().required(),
  message: Joi.string().required(),
  details: Joi.object()
    .pattern(Joi.string(), [Joi.string(), Joi.number()])
    .optional(),
});

export interface IErrorInfo {
  status: string;
  message: string;
  details?: IErrorDetails;
}

// used as a response when HTTP request fails
export interface IErrorResponse {
  error: IErrorInfo;
}

export interface IErrorDetails {
  [key: string]: string | number | undefined;
}

export type OptionalResponse<T, E = {}> = T | (E & IErrorResponse);

export type WhenNoError<T> = Exclude<T, IErrorResponse>;

export type WhenError<T> = Extract<T, IErrorResponse>;

export function isErrorResponse<T>(
  response: T
): response is Extract<T, IErrorResponse> {
  return 'error' in response;
}

export function isSuccessResponse<T>(
  response: T
): response is Exclude<T, IErrorResponse> {
  return !('error' in response);
}

export const addErrorDetails = (
  incomingError: IErrorInfo,
  details?: IErrorDetails
): IErrorInfo =>
  details
    ? {
        ...incomingError,
        details: { ...incomingError.details, ...details },
      }
    : incomingError;
